import React, { useState } from "react";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";

export const FAQItem: React.FC<{ q: string; a: React.ReactNode }> = ({
  q,
  a,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <div
      className={`
        group rounded-xl transition overflow-hidden
        ${open ? "bg-[#1b3a37]/80" : "bg-[#152D2B] hover:bg-[#1b3a37]/80"}
        ring-1 ring-transparent hover:ring-white/10
      `}
    >
      <button
        type="button"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-start justify-between gap-4 text-left px-5 py-4 sm:px-6 sm:py-5 transition 
                   focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white cursor-pointer"
      >
        <span className="text-base sm:text-[15px] font-medium pr-8">{q}</span>
        <Plus
          className={`h-5 w-5 shrink-0 transition-transform duration-200 ${
            open ? "rotate-45" : ""
          }`}
          aria-hidden="true"
        />
      </button>

      <motion.div
        initial={false}
        animate={{ height: open ? "auto" : 0, opacity: open ? 1 : 0 }}
        transition={{ duration: 0.22, ease: "easeInOut" }}
        style={{ overflow: "hidden" }}
      >
        <div className="px-5 pb-5 sm:px-6 sm:pb-6 text-sm text-white/70">
          {a}
        </div>
      </motion.div>
    </div>
  );
};
